// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bellibolt: PokeData = {
  "id": 939,
  "name": "bellibolt",
  "height": 12,
  "weight": 1130,
  "base_experience": 173,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "thunder-shock",
    "flail",
    "mud-slap",
    "zap-cannon",
    "spark",
    "charge",
    "slack-off",
    "weather-ball",
    "mud-shot",
    "sucker-punch",
    "discharge",
    "electric-terrain"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "mud-slap",
    "zap-cannon",
    "mud-shot",
    "electric-terrain",
    "thunderbolt",
    "quick-tempo",
    "volt-switch",
    "volt-crash",
    "electric-wrath",
    "thunder",
    "thunder-fang"
  ],
  "evolution_chain": {
    "id": 491,
    "item": null,
    "species": [
      {
        "name": "tadbulb",
        "order": 940,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bellibolt",
        "order": 941,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 938,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 159,
    "speed": 73,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
